(() => {
  const init = () => {
    const template = document.getElementById('OlouiooMobileFlow');
    const config = document.getElementById('OlouiooMobileFlowData');
    const scope = document.querySelector('.product-information');
    const details = scope?.querySelector('.product-information__details-wrapper');
    const picker = scope?.querySelector('variant-picker, signature-menu-picker') || scope?.querySelector('.buy-buttons-block');
    if (!template || !config || !details || !picker || !scope.querySelector('.buy-buttons-block product-form-component') || scope.dataset.omfReady) return;
    const data = JSON.parse(config.textContent);
    const decoder = document.createElement('textarea');
    const decode = value => {
      if (typeof value === 'string') { decoder.innerHTML = value; return decoder.value; }
      if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key,text]) => [key,decode(text)]));
      return value;
    };
    for (const key of ['continue','add','adding','viewCart','edit','styling','package','stepLabels','facts','included','quantityLabel','priceNote','perUnitPrice','stationContext','station','review']) data[key] = decode(data[key]);
    const setText = (node, value) => { const text = String(value ?? ''); if (node && node.textContent !== text) node.textContent = text; };
    const setDisabled = (node, value) => { const disabled = Boolean(value); if (node && node.disabled !== disabled) node.disabled = disabled; };
    const viewport = matchMedia('(max-width:749px)');
    let step = 0, added = false, pending = false, variant = data.variant;
    let refreshQueued = false, cartCount = null, pendingTimer, summaryKey = '', lastNavigation = -Infinity;
    let availableSteps = [0,1,2,3];
    let stationIncluded = false, stationDrafts = [], savingReview = false, reviewKey = "";
    pending = scope.querySelector('signature-menu-picker')?.dataset.variantPending === 'true';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:data.currency || 'AUD'});
    const fragment = template.content.cloneNode(true);
    const preview = fragment.querySelector('.omf-preview');
    const summaries = fragment.querySelector('.omf-summaries');
    const quantityCard = fragment.querySelector('[data-omf-quantity]');
    const bar = fragment.querySelector('.omf-bar');
    const lightbox = fragment.querySelector('.omf-lightbox');
    const afterSelection = fragment.querySelector('[data-omf-after-selection]');
    const reviewPanel = afterSelection.querySelector('[data-omf-review]');
    const includedPanel = afterSelection.querySelector('[data-omf-inclusions]');
    const errorPanel = afterSelection.querySelector('[data-omf-error]');
    const stationToggle = afterSelection.querySelector('[data-omf-station-include]');
    const stationOptions = afterSelection.querySelector('[data-omf-station-options]');
    const next = bar.querySelector('[data-omf-next]');
    const cart = bar.querySelector('[data-omf-cart]');
    const stationPrompt = bar.querySelector('[data-omf-station]');
    const stationRoot = document.querySelector('[data-rfs-root]');
    let stationBooking = null, stationItems = [];
    const image = preview.querySelector('img');
    const previewHome = document.createComment('Mobile preview position');
    const imageAnchor = document.createElement('div');
    imageAnchor.className = 'omf-image-anchor no-empty';
    const imageSpacer = document.createElement('div');
    imageSpacer.className = 'omf-image-spacer no-empty';
    imageSpacer.setAttribute('aria-hidden','true');
    const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
    let imageRequest = 0, requestedSource = '', scrollFrame = 0;
    let expandedHeight = 320, compactHeight = 145, shrinkStart = 0;
    let measuredWidth = 0, lastProgress = -1, nativeScroll = false;
    const stepsNav = preview.querySelector('.omf-steps');
    const previewLabel = preview.querySelector('[data-omf-enlarge]');
    const supportsScrollTimeline = !!window.CSS?.supports('animation-timeline','scroll(root block)') && !!window.CSS?.supports('animation-range','0px 1px');
    picker.before(previewHome);
    picker.before(preview, summaries);
    document.body.append(bar, lightbox);
    const barObserver = new ResizeObserver(() => {
      const height = Math.ceil(bar.getBoundingClientRect().height);
      if (viewport.matches && height > 0) document.body.style.setProperty('--omf-bar-height', `${height}px`);
    });
    barObserver.observe(bar);
    const updateStation = event => {
      if (String(event.detail?.sourceId) !== String(data.productId)) return;
      stationItems = (event.detail.items || []).filter(item => String(item.product_id) === String(event.detail.stationId));
      queueRefresh();
    };
    document.addEventListener('olouioo:refreshment:cart', updateStation);
    stationPrompt?.addEventListener('click', () => {
      if (!stationRoot || stationRoot.getAttribute('aria-busy') === 'true') return;
      stationRoot.dispatchEvent(new CustomEvent('olouioo:refreshment:open', { detail: { trigger: stationPrompt, defer:true } }));
    });
    const facts = document.createElement('p');
    facts.className = 'omf-facts';
    facts.textContent = data.facts;
    if (data.facts) details.querySelector('product-title')?.append(facts);
    scope.dataset.omfReady = 'true';
    const formComponent = () => scope.querySelector('.buy-buttons-block product-form-component');
    formComponent().after(afterSelection);
    const quantity = () => Math.max(1, Number(formComponent()?.querySelector('[name="quantity"]')?.value) || 1);
    const service = () => window.OlouiooService?.read(formComponent());
    for (const [selector, native] of [['[data-omf-minus]','.quantity-minus'],['[data-omf-plus]','.quantity-plus']]) {
      quantityCard?.querySelector(selector).addEventListener('click', () => formComponent()?.querySelector(native)?.click());
    }
    const optionGroups = () => {
      const native = scope.querySelector('variant-picker .variant-picker__form') || scope.querySelector('variant-picker');
      const signature = scope.querySelector('signature-menu-picker');
      const groups = [...(native?.children || []),...(signature?.children || [])].filter(group => !group.hidden && group.matches('fieldset,.variant-option,olouioo-table-colours,olouioo-table-furniture'));
      for (const group of groups) {
        const label = group.querySelector('legend,.variant-option__label-text')?.textContent || '';
        const styling = group.matches('olouioo-table-colours') || /cloth|linen|colo[u]?r|floral|styling|setup|presentation|format/i.test(label);
        group.dataset.omfGroup = data.guestsFirst ? (/finish|drinkware/i.test(label) ? '1' : '0') : (styling ? '0' : '1');
      }
      if (!data.guestsFirst && !groups.some(group => group.dataset.omfGroup === '0')) {
        const finish = groups.find(group => /finish|drinkware/i.test(group.querySelector('legend,.variant-option__label-text')?.textContent || ''));
        if (finish) finish.dataset.omfGroup = '0';
      }
      scope.querySelectorAll('.olouioo-drink-info,.olouioo-hosted-more').forEach(group => { group.dataset.omfGroup = data.guestsFirst ? '0' : '1'; });
      return groups;
    };
    const selectedValues = (groups, index) => groups.filter(group => group.dataset.omfGroup === String(index)).flatMap(group => {
      const fields = group.matches('olouioo-table-colours,olouioo-table-furniture') ? [...group.querySelectorAll('fieldset')] : [group];
      return fields.map(field => {
        const label = field.querySelector('legend,.variant-option__label-text')?.textContent.trim();
        const values = [...field.querySelectorAll('input:checked,select,[data-single-option]')].map(input => input.dataset.displayValue || input.value).filter(Boolean);
        return values.length ? `${label ? label + ': ' : ''}${values.join(', ')}` : '';
      }).filter(Boolean);
    });
    const stepTitles = groups => {
      const label = group => group.querySelector('legend,.variant-option__label-text')?.textContent.trim() || '';
      const text = value => String(value || '').replaceAll('&amp;','&');
      const names = data.stepLabels || {};
      const styling = groups.filter(group => group.dataset.omfGroup === '0');
      const packages = groups.filter(group => group.dataset.omfGroup === '1');
      let first = data.styling, second = data.package;
      if (styling.some(group => group.matches('olouioo-table-colours'))) first = names.tableStyling || first;
      else if (styling.length === 1) {
        const name = label(styling[0]);
        if (/cloth|linen/i.test(name)) first = names.linen || name;
        else if (/finish|drinkware/i.test(name)) first = names.drinkware || name;
        else first = name || first;
      }
      const drinks = packages.some(group => group.matches('.olouioo-drink-card-group') || /drink(?!ware)/i.test(label(group)));
      const guests = packages.some(group => /guest/i.test(label(group)));
      const furniture = packages.some(group => group.querySelector('[data-table-furniture]'));
      const servings = packages.some(group => group.dataset.countBasis === 'drinks');
      if (drinks && servings) second = names.servingsDrinks || second;
      else if (drinks && guests) second = names.guestsDrinks || second;
      else if (drinks && furniture) second = names.drinksFurniture || second;
      else if (packages.length === 1) second = drinks ? names.drinks || label(packages[0]) : label(packages[0]) || second;
      if (data.guestsFirst) return [text(names.guestsDrinks || data.styling),text(names.drinkware || data.package)];
      return [text(first),text(second)];
    };
    const resizeImage = (timestamp = performance.now()) => {
      scrollFrame = 0;
      if (!viewport.matches || nativeScroll || lightbox.open) return;
      const range = expandedHeight - compactHeight;
      const target = Math.min(1,Math.max(0,window.scrollY - shrinkStart) / Math.max(1,range));
      const progress = target;
      if (progress !== lastProgress) {
        const scale = (expandedHeight - range * progress) / expandedHeight;
        const transform = `translateZ(0) scale(${scale})`;
        image.style.transform = transform;
        if(image.omfPlateLayer) image.omfPlateLayer.style.transform=transform;
        if(image.omfFurnitureLayer) image.omfFurnitureLayer.style.transform=transform;
        stepsNav.style.transform = `translate3d(0,${-range * progress}px,0)`;
        previewLabel.style.transform = stepsNav.style.transform;
        lastProgress = progress;
      }

    };
    const queueImageResize = () => {
      if (!scrollFrame && viewport.matches && !nativeScroll) scrollFrame = requestAnimationFrame(resizeImage);
    };
    const measureImage = (force = false) => {
      if (!viewport.matches || !imageAnchor.isConnected || lightbox.open) return;
      const width = details.clientWidth || window.innerWidth;
      if (force !== true && measuredWidth === width) return;
      measuredWidth = width;
      expandedHeight = Math.min(250,Math.max(180,Math.min(width * 0.65,window.innerHeight * 0.3)));
      compactHeight = Math.min(124,Math.max(96,window.innerHeight * 0.14));
      if (reducedMotion.matches) expandedHeight = compactHeight;
      shrinkStart = imageAnchor.getBoundingClientRect().top + window.scrollY;
      preview.style.setProperty('--omf-expanded-height', `${expandedHeight}px`);
      preview.style.setProperty('--omf-compact-height', `${compactHeight}px`);
      imageSpacer.style.height = `${expandedHeight - compactHeight}px`;
      nativeScroll = supportsScrollTimeline && !reducedMotion.matches && expandedHeight > compactHeight;
      preview.style.setProperty('--omf-scroll-start',`${shrinkStart}px`);
      preview.style.setProperty('--omf-scroll-end',`${shrinkStart + expandedHeight - compactHeight}px`);
      preview.style.setProperty('--omf-final-scale',String(compactHeight / expandedHeight));
      preview.style.setProperty('--omf-final-shift',`${compactHeight - expandedHeight}px`);
      preview.classList.toggle('omf-native-scroll',nativeScroll);
      image.style.removeProperty('transform');
      image.omfPlateLayer?.style.removeProperty('transform');
      image.omfFurnitureLayer?.style.removeProperty('transform');
      stepsNav.style.removeProperty('transform');
      previewLabel.style.removeProperty('transform');
      cancelAnimationFrame(scrollFrame); scrollFrame = 0;
      lastProgress = -1;
      scope.style.setProperty('--omf-compact-height',`${compactHeight}px`);
      resizeImage();
    };
    window.addEventListener('scroll',queueImageResize,{passive:true});
    window.addEventListener('resize',measureImage,{passive:true});
    window.addEventListener('load',measureImage,{once:true});
    document.fonts?.ready.then(() => measureImage(true));
    const servicePreviewImage = () => {
      const gallery = scope.querySelector('[data-service-preview-gallery]');
      const template = gallery?.dataset.previewTemplate;
      if (!template) return '';
      const colour = value => String(value || '').toLowerCase().replaceAll(' ','-');
      const valid = new Set(['ivory','white','deep-green','burgundy']);
      if (gallery.dataset.serviceHandle === 'olouioo-signature-coupe-tower-setup-upgrade') {
        const selected = colour(variant?.option2 || variant?.options?.[1]).replace('off-white','ivory');
        const linen = valid.has(selected) ? selected : 'ivory';
        return template.replace('olouioo-tower-crystal-ivory.png',`olouioo-tower-crystal-${linen}.png`);
      }
      if (gallery.dataset.serviceHandle === 'la-table') {
        const parts = String(variant?.option1 || variant?.options?.[0] || '').toLowerCase().split(' / ');
        const selectedCloth = colour(parts[0]), selectedFlorals = colour(parts[1]?.replace(/ florals$/,''));
        const cloth = valid.has(selectedCloth) ? selectedCloth : 'ivory';
        const florals = valid.has(selectedFlorals) ? selectedFlorals : 'ivory';
        return template.replace('olouioo-style-ivory-ivory-crystal-white.webp',`olouioo-style-${cloth}-${florals}-crystal-white.webp`);
      }
      return '';
    };
    const updateImage = (immediate = false) => {
      const original = servicePreviewImage() || scope.querySelector('[data-signature-linen]:checked')?.dataset.linenImage || variant?.featured_image?.src || variant?.featured_media?.preview_image?.src || data.image?.src;
      const source = window.OlouiooTableStyling?.source(original) || original;
      if (!source || source === requestedSource) return;
      requestedSource = source;
      const resized = new URL(source,location.href);
      if (/\/cdn\/shop\/|\/s\/files\//.test(resized.pathname)) resized.searchParams.set('width','900');
      const previewSource = resized.href;
      const request = ++imageRequest;
      const alt = variant?.featured_image?.alt || data.productTitle || image.alt;
      const commit = () => {
        if(request !== imageRequest) return;
        image.removeAttribute('srcset'); image.src = previewSource; image.alt = alt;
        if (lightbox.open) lightbox.querySelector('img').src = previewSource;
      };
      if(immediate || image.getAttribute('src') === previewSource) { commit(); return; }
      const incoming = new Image();
      incoming.onload = () => {
        if(incoming.decode) incoming.decode().catch(() => {}).then(commit);
        else commit();
      };
      incoming.onerror = () => { if(request === imageRequest) requestedSource = ''; };
      incoming.src = previewSource;
    };
    const summary = (index, title, values) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'omf-summary';
      const heading = document.createElement('strong'); heading.textContent = title;
      const edit = document.createElement('em'); edit.textContent = data.edit;
      const description = document.createElement('span'); description.textContent = values.join(' · ');
      button.append(heading, edit, description);
      button.addEventListener('click', () => go(index));
      return button;
    };
    const validateEvent = () => {
      const fields = [...(formComponent()?.querySelectorAll('[data-event-date],[data-start-time],[data-hire-duration]') || [])];
      const invalid = fields.find(field=>!field.checkValidity());
      if(!invalid) return true;
      step = 2; refresh();
      requestAnimationFrame(()=>{invalid.scrollIntoView({block:'center',behavior:'smooth'});invalid.focus({preventScroll:true});invalid.reportValidity();});
      return false;
    };
    const openDraft = (trigger,draftId) => {
      if(!stationRoot || stationRoot.dataset.ready !== 'true' || savingReview) return;
      stationRoot.dispatchEvent(new CustomEvent('olouioo:refreshment:open',{detail:{trigger,defer:true,draftId}}));
    };
    const stationConfigure = reviewPanel.querySelector('[data-omf-configure-station]');
    stationConfigure?.addEventListener('click',()=>openDraft(stationConfigure));
    stationToggle?.addEventListener('change',()=>{stationIncluded=stationToggle.checked;added=false;errorPanel.hidden=true;queueRefresh();});
    document.addEventListener('olouioo:refreshment:draft',event=>{
      if(String(event.detail?.sourceId)!==String(data.productId)) return;
      stationDrafts=event.detail.drafts || [];
      stationIncluded=stationDrafts.length>0;
      added=false;reviewKey='';queueRefresh();
    });
    const selectedState = selectedService => {
      const property=name=>scope.querySelector(`[data-table-property="${name}"]:checked`)?.value;
      const linen=scope.querySelector('[data-table-colour="1"]:checked')?.value || scope.querySelector('[data-signature-linen]:checked')?.value || variant?.option2 || '';
      const menus=[...scope.querySelectorAll('.olouioo-drink-card-group input:checked,signature-menu-picker [name="signature-drinks"]:checked,signature-menu-picker [data-signature-drink]:checked')].map(input=>input.dataset.displayValue || input.value);
      const finish=['la-coupe-welcome-toast-table','olouioo-signature-coupe-tower-setup-upgrade'].includes(data.handle) ? 'Glass' : selectedService?.finish || variant?.option1?.split(' · ')[0] || '';
      return {handle:data.handle,hosted:data.hosted,quantity:quantity(),guests:selectedService?.guests || (data.handle==='la-table'?quantity()*8:0),drinks:selectedService?.drinkCount || 0,hours:selectedService?.hours || 3,plate:property('Plate style') || property('Plate material') || data.review.plate_crystal,napkin:property('Napkin colour') || 'White',cloth:linen,florals:scope.querySelector('[data-table-colour="2"]:checked')?.value || '',drinkware:finish,menu:menus.join(', ') || variant?.option3 || '',furniture:scope.querySelector('[data-table-furniture]:checked')?.value==='Yes'};
    };
    const renderReview = (groups,selectedService,titles) => {
      includedPanel.hidden = step !== 2;
      reviewPanel.hidden = step !== 3;
      const state=selectedState(selectedService);
      const eventValues=window.OlouiooServiceDetails?.eventSummary(formComponent(),data.review) || [];
      const choices=[selectedValues(groups,0),selectedValues(groups,1)];
      const key=JSON.stringify([step,state,choices,eventValues,stationIncluded,stationDrafts]);
      if(key===reviewKey) return;
      reviewKey=key;
      const list=includedPanel.querySelector('[data-omf-inclusion-list]');
      list.replaceChildren(...(window.OlouiooServiceDetails?.inclusions(state,data.review.inclusions)||[]).map(text=>{const item=document.createElement('li');item.textContent=text;return item;}));
      const cards=[];
      for(const index of [0,1]) if(availableSteps.includes(index)) cards.push(summary(index,titles[index],choices[index]));
      if(selectedService) cards.push(summary(data.guestsFirst?0:1,data.quantityLabel,[selectedService.title,selectedService.summary]));
      cards.push(summary(2,data.review.event,eventValues));
      reviewPanel.querySelector('[data-omf-review-selections]').replaceChildren(...cards);
      if(stationToggle) {
        stationToggle.checked=stationIncluded;
        stationToggle.disabled=savingReview;
        stationOptions.hidden=!stationIncluded;
        setText(reviewPanel.querySelector('[data-omf-station-state]'),stationIncluded ? data.review.station_selected.replace('{count}',stationDrafts.length) : data.review.station_excluded);
        setText(stationConfigure,stationDrafts.length?data.review.station_add_another:data.review.station_configure);
        const rows=stationDrafts.map((draft,index)=>{
          const row=document.createElement('article');row.className='omf-draft-station';
          const heading=document.createElement('strong');heading.textContent=data.review.station+' '+(index+1);
          const description=document.createElement('p');description.textContent=draft.description;
          const price=document.createElement('p');price.textContent=money.format(draft.total/100);
          const actions=document.createElement('div');actions.className='omf-draft-actions';
          const edit=document.createElement('button');edit.type='button';edit.textContent=data.edit;edit.setAttribute('aria-label',data.review.station_edit.replace('{count}',index+1));edit.addEventListener('click',()=>openDraft(edit,draft.id));
          const remove=document.createElement('button');remove.type='button';remove.textContent=data.review.remove;remove.setAttribute('aria-label',data.review.station_remove.replace('{count}',index+1));remove.addEventListener('click',()=>stationRoot.olouiooReview.removeDraft(draft.id));
          actions.append(edit,remove);row.append(heading,description,price,actions);return row;
        });
        reviewPanel.querySelector('[data-omf-station-drafts]').replaceChildren(...rows);
      }
    };
    const proceedToCheckout = async current => {
      if(!Array.isArray(current?.items)) {
        const response=await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error(data.review.error);
        current=await response.json();
        if(!Array.isArray(current?.items))throw new Error(data.review.error);
      }
      const tables=current.items.reduce((count,item)=>count+(item.handle==='la-table'?Number(item.quantity)||0:0),0);
      if(tables>0 && tables<3) {
        errorPanel.textContent=data.review.table_minimum;errorPanel.hidden=false;
        errorPanel.scrollIntoView({block:'nearest',behavior:reducedMotion.matches?'instant':'smooth'});
        return;
      }
      location.assign(data.checkoutUrl);
    };
    const confirmBooking = async checkout => {
      if(savingReview || pending || !variant?.available) return;
      if(!added) {
        if(!validateEvent()) return;
        if(stationIncluded && !stationDrafts.length) {errorPanel.textContent=data.review.station_choose_required;errorPanel.hidden=false;stationConfigure?.focus();return;}
        if(!stationRoot?.olouiooReview) {errorPanel.textContent=data.review.loading;errorPanel.hidden=false;return;}
      }
      savingReview=true;errorPanel.hidden=true;refresh();
      try {
        let current;
        if(!added) {
          const result=await stationRoot.olouiooReview.submit(stationIncluded);
          if(!result) return;
          added=true;current=result.cart;
          if(current) cartCount=window.OlouiooDuration?.displayCount(current.items) ?? current.item_count;
        }
        if(checkout) await proceedToCheckout(current);
      } catch(error) {errorPanel.textContent=error.message || data.review.error;errorPanel.hidden=false;}
      finally {savingReview=false;refresh();}
    };
    const refresh = () => {
      refreshQueued = false;
      if (!viewport.matches) return;
      const groups = optionGroups();
      const selectedService = service();
      try { stationDrafts = stationRoot?.olouiooReview?.getDrafts() || []; } catch { stationDrafts = []; }
      const stationCount = stationDrafts.length;
      stationBooking = stationCount ? {count:stationCount} : null;
      const titles = [...stepTitles(groups),data.review.event_step,data.review.step];
      availableSteps = [0,1].filter(index => groups.some(group => group.dataset.omfGroup === String(index))).concat(2,3);
      if (!availableSteps.includes(step)) step = availableSteps[0];
      scope.dataset.omfStep = String(step);
      document.body.dataset.omfStep = String(step);
      if (stationPrompt) {
        stationPrompt.hidden = step !== 2 || !stationRoot;
        stationPrompt.disabled = stationRoot?.dataset.ready !== 'true' || stationRoot?.getAttribute('aria-busy') === 'true';
        stationPrompt.setAttribute('aria-controls', stationRoot?.querySelector('[data-rfs-panel]')?.id || '');
        stationPrompt.setAttribute('aria-label', data.review.station_configure);
        setText(stationPrompt.querySelector('[data-omf-station-badge]'),data.station.optional);
        setText(stationPrompt.querySelector('[data-omf-station-description]'),selectedService ? String(data.stationContext).replace('{service}',selectedService.shortTitle).replace('{quantity}',selectedService.summary) : data.station.description);
        setText(stationPrompt.querySelector('[data-omf-station-action]'),data.station.customise);
        stationPrompt.querySelector('[data-omf-station-plus]').hidden = false;
      }
      stepsNav.style.setProperty('--omf-step-count',String(availableSteps.length));
      preview.querySelectorAll('[data-omf-step]').forEach(button => {
        const index = availableSteps.indexOf(Number(button.dataset.omfStep));
        button.hidden = index === -1;
        button.querySelector('span').textContent = String(index + 1);
        const title = titles[Number(button.dataset.omfStep)];
        if (title) button.querySelector('span:last-child').textContent = title;
        if (Number(button.dataset.omfStep) === step) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
      if (selectedService && quantityCard) {
        quantityCard.hidden = step !== (data.guestsFirst ? 0 : 1);
        setText(quantityCard.querySelector('[data-omf-quantity-heading]'),selectedService.heading);
        setText(quantityCard.querySelector('[data-omf-quantity-description]'),selectedService.allowance);
        setText(quantityCard.querySelector('[data-omf-count]'),quantity());
        setText(quantityCard.querySelector('[data-omf-unit-price]'),selectedService.units);
        const native = formComponent()?.querySelector('[name="quantity"]');
        setDisabled(quantityCard.querySelector('[data-omf-minus]'),quantity() <= Number(native?.min || 1));
        setDisabled(quantityCard.querySelector('[data-omf-plus]'),native?.max && quantity() >= Number(native.max));
      }
      const quantityVisible = selectedService && quantityCard && !quantityCard.hidden;
      if(quantityVisible && summaries.firstElementChild !== quantityCard) summaries.replaceChildren(quantityCard);
      else if(!quantityVisible && summaries.childNodes.length) summaries.replaceChildren();
      renderReview(groups,selectedService,titles);
      const stationCost = step === 3 && stationIncluded ? stationDrafts.reduce((sum,item)=>sum+item.total,0) : 0;
      setText(bar.querySelector('[data-omf-total]'),money.format(((variant?.price || 0) * quantity() + (window.OlouiooDuration?.cost(formComponent()) || 0) + stationCost) / 100));
      setText(bar.querySelector('[data-omf-total-note]'),step === 3 ? data.review.total_note : selectedService ? selectedService.units + ' · ' + data.priceNote : data.priceNote);
      const nativeButton = formComponent()?.querySelector('[ref="addToCartButton"]');
      const busy = formComponent()?.getAttribute('aria-busy') === 'true';
      reviewPanel.inert=savingReview;
      if(stationToggle) stationToggle.disabled=savingReview;
      setDisabled(next,savingReview || pending || (step === 3 && (busy || !variant?.available || nativeButton?.disabled)));
      setDisabled(reviewPanel.querySelector('[data-omf-save]'),savingReview || pending || !variant?.available || busy);
      preview.querySelectorAll('[data-omf-step]').forEach(button=>{button.disabled=savingReview;});
      setText(next,savingReview || busy ? data.adding : step === 2 ? data.review.continue_review : step === 3 ? data.review.checkout : data.continue);
      next.hidden = added;
      reviewPanel.querySelector('[data-omf-save]').hidden = added;
      cart.hidden = !added;
      setText(cart,data.viewCart + (cartCount === null ? '' : ` · ${cartCount}`));
    };
    const queueRefresh = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(refresh);
    };
    const go = index => {
      if (!availableSteps.includes(index) || savingReview) return;
      if(index === 3 && !validateEvent()) return;
      step = index;
      refresh();
      const target = step === 3 ? afterSelection : step === 2 ? formComponent()?.querySelector('event-booking-fields') || afterSelection : picker;
      const destination = target.getBoundingClientRect().top + window.scrollY - preview.getBoundingClientRect().height - 16;
      window.scrollTo({top:Math.max(shrinkStart + expandedHeight - compactHeight,destination),behavior:reducedMotion.matches ? 'instant':'smooth'});
      preview.querySelector(`[data-omf-step="${step}"]`).focus({preventScroll:true});
    };
    preview.querySelectorAll('[data-omf-step]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.omfStep))));
    let dialogAnimation, closingPreview = false, savedScroll = 0, savedBodyStyles;
    const closePreview = () => {
      if (!lightbox.open || closingPreview) return;
      closingPreview = true;
      dialogAnimation?.cancel();
      lightbox.classList.add('omf-closing');
      const finish = () => {
        lightbox.close();
        lightbox.classList.remove('omf-closing');
        Object.assign(document.body.style,savedBodyStyles);
        window.scrollTo({top:savedScroll,behavior:'instant'});
        measureImage(true);
        preview.querySelector('.omf-image-button').focus({preventScroll:true});
        closingPreview = false;
      };
      if (reducedMotion.matches || typeof lightbox.animate !== 'function') { finish(); return; }
      dialogAnimation = lightbox.animate([{opacity:1,transform:'scale(1)'},{opacity:0,transform:'scale(.97)'}],{duration:160,easing:'ease-in',fill:'forwards'});
      dialogAnimation.finished.then(finish).catch(() => {});
    };
    preview.querySelector('.omf-image-button').addEventListener('click', () => {
      if (lightbox.open) return;
      dialogAnimation?.cancel();
      const modalImage = lightbox.querySelector('img');
      modalImage.src = image.currentSrc || image.src;
      lightbox.querySelector('img').alt = image.alt;
      window.OlouiooTableStyling?.updatePlateLayer?.(lightbox.querySelector('img'));
      savedScroll = window.scrollY;
      if (nativeScroll) {
        nativeScroll = false;
        preview.classList.remove('omf-native-scroll');
        lastProgress = -1;
        resizeImage();
      }
      savedBodyStyles = Object.fromEntries(['position','top','width','overflow'].map(key => [key,document.body.style[key]]));
      Object.assign(document.body.style,{position:'fixed',top:`-${savedScroll}px`,width:'100%',overflow:'hidden'});
      lightbox.showModal();
      if (!reducedMotion.matches && typeof lightbox.animate === 'function') {
        dialogAnimation = lightbox.animate([{opacity:0,transform:'scale(.97)'},{opacity:1,transform:'scale(1)'}],{duration:200,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
    });
    lightbox.querySelector('button').addEventListener('click',closePreview);
    lightbox.addEventListener('cancel',event => { event.preventDefault(); closePreview(); });
    lightbox.addEventListener('click', event => { if(event.target === lightbox) closePreview(); });
    next.addEventListener('click', () => {
      if (performance.now() - lastNavigation < 250 || savingReview) return;
      if(step < 3) { lastNavigation = performance.now(); go(availableSteps[availableSteps.indexOf(step)+1]); return; }
      confirmBooking(true);
    });
    reviewPanel.querySelector('[data-omf-save]').addEventListener('click',()=>confirmBooking(false));
    scope.addEventListener('change', event => {
      added = false;
      errorPanel.hidden = true;
      if (event.target.matches('[data-table-colour],[data-table-property],[data-signature-linen]')) updateImage();
      queueRefresh();
    }, true);
    scope.addEventListener('input', queueRefresh, true);
    scope.addEventListener('olouioo:table-details', () => { added = false; updateImage(); queueRefresh(); });
    scope.addEventListener('quantity-selector:update', () => { added = false; queueRefresh(); });
    scope.addEventListener('variant:selected', () => {
      pending = true; added = false; queueRefresh();
      if (step === 3) next.disabled = true;
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(() => { pending = false; queueRefresh(); },15000);
    });
    document.addEventListener('variant:update', event => {
      if (String(event.detail?.data?.productId) !== String(data.productId) || !scope.contains(event.target)) return;
      variant = event.detail.resource; pending = false; clearTimeout(pendingTimer);
      updateImage(); queueRefresh();
    });
    scope.addEventListener('olouioo:service-variant', event => {
      if (String(event.detail?.productId) !== String(data.productId)) return;
      pending = event.detail.status === 'pending';
      if (pending && step === 3) next.disabled = true;
      added = false;
      if (event.detail.status === 'ready') { variant = event.detail.variant; updateImage(); }
      if (event.detail.status === 'error') variant = null;
      queueRefresh();
    });
    document.addEventListener('cart:update', event => {
      if (!['product-form-component','service-station-booking'].includes(event.detail?.data?.source) || String(event.detail?.data?.productId) !== String(data.productId)) return;
      added = true; pending = false; queueRefresh();
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js',{headers:{Accept:'application/json'}})
        .then(response => response.ok ? response.json() : null)
        .then(result => { if(result) cartCount = window.OlouiooDuration?.displayCount(result.items) ?? result.item_count; queueRefresh(); }).catch(() => {});
    });
    window.addEventListener('cart:error', () => { pending = false; queueRefresh(); });
    document.addEventListener('shopify:variant:change', event => {
      if (event.detail?.error) { pending = false; queueRefresh(); }
    });
    document.addEventListener('olouioo:service-state', queueRefresh);
    const observer = new MutationObserver(records => {
      if (records.some(record => !summaries.contains(record.target))) queueRefresh();
    });
    observer.observe(formComponent(), {attributes:true,attributeFilter:['aria-busy','disabled'],subtree:true});
    if (stationRoot) observer.observe(stationRoot, {attributes:true,attributeFilter:['data-ready','aria-busy']});
    const accordion = details.querySelector('.accordion accordion-custom');
    const description = accordion?.querySelector('details');
    const originallyOpen = description?.open;
    const descriptionLabel = [...(description?.querySelector('summary')?.childNodes || [])].find(node => node.nodeType === 3 && node.textContent.trim());
    const originalLabel = descriptionLabel?.textContent;
    const enable = () => {
      if(viewport.matches) details.prepend(imageAnchor,preview,imageSpacer);
      else { previewHome.after(preview); imageAnchor.remove(); imageSpacer.remove(); }
      scope.classList.toggle('omf-active',viewport.matches);
      document.body.classList.toggle('omf-enabled',viewport.matches);
      document.body.classList.toggle('omf-station-prompt',viewport.matches && !!stationPrompt && !!stationRoot);
      document.body.dataset.omfStep=String(step);
      document.querySelectorAll('#MainContent product-recommendations,#MainContent recently-viewed-products,#MainContent recently-viewed').forEach(node=>node.closest('.shopify-section')?.setAttribute('data-omf-extra',''));
      if(!viewport.matches) delete document.body.dataset.omfStep;
      if(description) {
        description.open = viewport.matches ? false : originallyOpen;
        if(viewport.matches) accordion.removeAttribute('open-by-default-on-mobile');
      }
      if(descriptionLabel) descriptionLabel.textContent = viewport.matches ? data.included : originalLabel;
      if(viewport.matches) { refresh(); measureImage(true); }
      else if(lightbox.open) closePreview();
    };
    document.addEventListener('focusin', event => document.body.classList.toggle('omf-keyboard',viewport.matches && event.target.matches('input:not([type=radio]):not([type=checkbox]):not([type=hidden]),textarea')));
    document.addEventListener('focusout', () => document.body.classList.remove('omf-keyboard'));
    viewport.addEventListener('change',enable);
    reducedMotion.addEventListener('change',() => measureImage(true));
    enable(); updateImage(true);
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();






